import { render } from "./TakerPage.vue?vue&type=template&id=1f5f37b2&ts=true"
import script from "./TakerPage.vue?vue&type=script&lang=ts"
export * from "./TakerPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__